import { Link } from "react-router-dom";
import s from "./platformAdmin.module.css";
import {
  activityTone,
  clinicStatusLabel,
  daysLeftLabel,
  formatDateRu,
  formatDateTimeRu,
  formatRelativeActivity,
  formatRub,
  statusClass,
} from "./platformClubsUtils";

function OwnerContact({ owner }) {
  if (!owner) {
    return <span className={s.clubMetaMuted}>Владелец не найден</span>;
  }
  return (
    <div className={s.clubOwner}>
      <strong>{owner.full_name || "Владелец"}</strong>
      <div className={s.clubOwnerLinks}>
        {owner.email ? (
          <a href={`mailto:${owner.email}`} className={s.clubContactLink}>
            {owner.email}
          </a>
        ) : null}
        {owner.phone ? (
          <a href={`tel:${owner.phone}`} className={s.clubContactLink}>
            {owner.phone}
          </a>
        ) : null}
      </div>
    </div>
  );
}

function ActivityBadge({ clinic }) {
  const at = clinic.activity?.last_activity_at;
  const tone = activityTone(at);
  return (
    <div className={s.clubActivity}>
      <span className={`${s.activityDot} ${s[`activityDot${tone}`]}`} aria-hidden />
      <div>
        <strong>{formatRelativeActivity(at)}</strong>
        <small>
          {clinic.activity?.last_staff_login_at
            ? `Вход: ${formatDateTimeRu(clinic.activity.last_staff_login_at)}`
            : "Входов не было"}
        </small>
      </div>
    </div>
  );
}

function StatusPill({ clinic }) {
  const cls = statusClass(clinic.status, clinic.billing);
  return (
    <span className={`${s.statusPill} ${s[cls]}`}>
      {clinicStatusLabel(clinic)}
    </span>
  );
}

function Chevron() {
  return (
    <svg
      className={s.clubRowChevron}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M9 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function PlatformClubsList({
  clinics,
  onStatusChange,
  showStatusSelect = false,
  showDeleteClinicActions = false,
  onDeleteClinic,
  emptyText = "Клубов пока нет",
}) {
  if (!clinics.length) {
    return <p className={s.emptyHint}>{emptyText}</p>;
  }

  return (
    <>
      <div className={s.clubMobileList}>
        {clinics.map((c) => (
          <Link
            key={c.id}
            to={`/admin/tenants/${c.id}`}
            className={s.clubMobileRow}
          >
            <div className={s.clubMobileRowMain}>
              <div className={s.clubMobileRowTop}>
                <strong className={s.clubMobileName}>{c.name}</strong>
                <StatusPill clinic={c} />
              </div>
              <div className={s.clubMobileMeta}>
                <span>{c.owner?.full_name || c.owner?.email || "Без владельца"}</span>
                <span aria-hidden>·</span>
                <span>{c.subdomain}</span>
              </div>
              <div className={s.clubMobileMeta}>
                <span>
                  {c.billing?.plan_label || c.plan?.name || c.plan_tier || "Тариф —"}
                </span>
                <span aria-hidden>·</span>
                <span>{daysLeftLabel(c.billing?.days_left)}</span>
              </div>
              <div className={s.clubMobileStats}>
                <span>{c.stats?.clients ?? 0} кл.</span>
                <span>{c.stats?.trainers ?? 0} тр.</span>
                <span className={s.clubMobileActivity}>
                  {formatRelativeActivity(c.activity?.last_activity_at)}
                </span>
              </div>
            </div>
            <Chevron />
          </Link>
        ))}
      </div>

      <div className={s.clubTableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>Клуб</th>
              <th>Владелец</th>
              <th>Активность</th>
              <th>Тариф</th>
              <th>Оплата</th>
              <th>Клиенты</th>
              <th>Выручка 30д</th>
              {showStatusSelect ? <th>Статус</th> : null}
              {showDeleteClinicActions ? <th /> : null}
            </tr>
          </thead>
          <tbody>
            {clinics.map((c) => (
              <tr key={c.id}>
                <td>
                  <Link to={`/admin/tenants/${c.id}`} className={s.subClubLink}>
                    <strong>{c.name}</strong>
                    <small>{c.subdomain}</small>
                  </Link>
                </td>
                <td>
                  <OwnerContact owner={c.owner} />
                </td>
                <td>
                  <ActivityBadge clinic={c} />
                </td>
                <td>{c.billing?.plan_label || c.plan?.name || c.plan_tier || "—"}</td>
                <td>
                  {formatDateRu(c.billing?.paid_until)}
                  <br />
                  <small>{daysLeftLabel(c.billing?.days_left)}</small>
                </td>
                <td>{c.stats?.clients ?? 0}</td>
                <td>{formatRub(c.stats?.revenue_30d)} ₽</td>
                {showStatusSelect ? (
                  <td>
                    <select
                      value={c.status}
                      onChange={(e) => onStatusChange?.(c.id, e.target.value)}
                    >
                      <option value="trial">trial</option>
                      <option value="active">active</option>
                      <option value="suspended">suspended</option>
                    </select>
                  </td>
                ) : null}
                {showDeleteClinicActions ? (
                  <td style={{ width: 140, textAlign: "right" }}>
                    <button
                      type="button"
                      className={`${s.btn} ${s.btnDanger}`}
                      onClick={() => onDeleteClinic?.(c.id)}
                      disabled={!onDeleteClinic}
                    >
                      Удалить
                    </button>
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
